import { PolymerElement, html } from '@polymer/polymer';
import '@wdpr/avenir-typography';
import '@wdpr/color';
import '@wdpr/mdx-icons';
import { interval } from 'rxjs';
import { ajax } from 'rxjs/ajax';

import './style/wdpr-wc-travel-agent-session-background-refresh-style.js';

class WdprWcTravelAgentSessionBackgroundRefresh extends PolymerElement {

  static get is() {
    return 'wdpr-wc-travel-agent-session-background-refresh';
  }

  static get properties() {
    return {
      extendUrl: {
        type: String
      },
      extendInterval: {
        type: Number,
        observer: '_extendIntervalObserver'
      },
      expirationResponseCodes: {
        type: Array,
        value: [403]
      },
      _intervalReference: {
        type: Object,
        value: null
      }
    }
  }

  static get template() {
    return html``;
  }

  _extendIntervalObserver() {
    this._start();
  }

  _start() {
    this._intervalReference = interval(this.extendInterval)
      .subscribe(this._extend.bind(this));
  }

  _extend() {
    this._callURL().subscribe(
      (res) => this._handleSessionSuccess(res),
      (err) => this._handleSessionError(err)
    );
  }

  _callURL() {
    return ajax.get(this.extendUrl);
  }

  _handleSessionSuccess(res) {
  }

  _handleSessionError(err) {
    this.dispatchEvent(new CustomEvent('requestError', {
      detail: {
        error: err
      }
    }));
    if (this.expirationResponseCodes.includes(err.status)) {
      this._stop();
    }
  }

  _stop() {
    this._intervalReference.unsubscribe();
  }

}

window.customElements.define(WdprWcTravelAgentSessionBackgroundRefresh.is, WdprWcTravelAgentSessionBackgroundRefresh);
